/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */

<template>
  <div class="position-relative">
    <no-ssr>
      <v-select
        class="form-control"
        :class="[{'is-invalid': validState === false}, selectClass, {'has-value': valueComputed !== null, 'body-appended': appendToBody }]"
        :id="id"
        :name="name"
        :options="options"
        :state="validState"
        :placeholder="placeholder"
        :autocomplete="autocomplete"
        :ref="id"
        :required="required"
        :disabled="disabled"
        :readonly="readonly"
        :data-vv-scope="dataVvScope"
        :clearable="clearable"
        :reduce="reduce"
        :searchable="searchable"
        :selectable="selectable"
        :appendToBody="appendToBody"
        :components="{ Deselect }"
        v-model="valueComputed"
        >
        <template #open-indicator="{ attributes }">
          <span v-bind="attributes">
            <svg class="o-icon"><use xlink:href="#arrow-down"></use></svg>
          </span>
        </template>
        <template #option="opt">
          <slot name="option" v-bind="opt"></slot>
        </template>
        <template slot="selected-option" slot-scope="opt">
          <slot name="option" v-bind="opt"></slot>
        </template>
        <span slot="no-options">{{ $t('nothing here') }}</span>
      </v-select>
    </no-ssr>
    <b-form-invalid-feedback >
      <!-- This will only be shown if the preceeding input has an invalid state -->
      <div v-for="(validation, index) in validationsFiltered"
        :key="index">
        {{ validation.text }}
      </div>
    </b-form-invalid-feedback>
    <b-form-text v-if="info">
      <!-- this is a form text block (formerly known as help block) -->
      {{ info }}
    </b-form-text>
  </div>
</template>

<script>
import filter from 'lodash/filter'
import DeselectButton from 'theme/components/Form/DeselectButton'

export default {
  props: {
    value: {
      type: [String, Number, Object],
      required: false,
      default: ''
    },
    name: {
      type: String,
      required: false,
      default: ''
    },
    placeholder: {
      type: String,
      required: false,
      default: ''
    },
    autocomplete: {
      type: String,
      required: false,
      default: ''
    },
    info: {
      type: String,
      required: false,
      default: ''
    },
    focus: {
      type: Boolean,
      required: false,
      default: false
    },
    autofocus: {
      type: Boolean,
      required: false,
      default: false
    },
    searchable: {
      type: Boolean,
      required: false,
      default: true
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    appendToBody: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    validations: {
      type: Array,
      required: false,
      default: () => []
    },
    dataVvScope: {
      type: String
    },
    options: {
      type: Array,
      default: () => []
    },
    clearable: {
      type: Boolean,
      default: true
    },
    reduce: {
      type: Function
    },
    selectable: {
      type: Function
    },
    selectClass: {
      type: String,
      required: false,
      default: ''
    }
  },
  data: () => ({
    _loading: false,
    Deselect: DeselectButton
  }),
  mounted () {
    if (this.focus) {
      this.$refs[this.id].focus()
    }
  },
  computed: {
    id () {
      return this._uid + '_' + this.name
    },
    valueComputed: {
      get () {
        return this.value
      },
      set (newValue) {
        this.$emit('input', newValue)
        return newValue
      }
    },
    validState () {
      return this.validationsFiltered.length ? false : null
    },
    validationsFiltered () {
      return filter(this.validations, { condition: true })
    }
  },
  methods: {
    loading (status) {
      const _this = this
      this._loading = status
      if (this.$refs[this.id]) {
        this.$refs[this.id].mutableLoading = status
      } else {
        setTimeout(() => {
          _this.loading(_this._loading)
        }, 500)
      }
    }
  },
  components: {
    DeselectButton
  }
}
</script>
